module.exports = __webpack_public_path__ + "static/img/idepa@2x.46b17a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/idepa@2x.png
// module id = DsNE
// module chunks = 0